/* Generated from maintained first-touch sources; see the release deployment record. */
(function () {
/* Shared ES2020 code. No Node/browser-only APIs: also runs in Shopify Flow. */
const VFUTM = (() => {
  const prefix = 'vfutm1_';
  const chunkSize = 180;
  const maxChunks = 32;
  const maxAgeMs = 90 * 86400000;
  const parameters = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  const fieldKeys = ['first_touch_at', ...parameters.map(k => 'first_touch_' + k), 'lead_submitted_at', 'first_touch_referrer_host'];
  const hostPattern = /^(?=.{1,253}$)(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z](?:[a-z0-9-]{0,61}[a-z0-9])?$/;
  const tagPattern = /^vfutm1_([a-f0-9]{32})_(\d{2})_(\d{2})_([a-f0-9]+)$/i;
  function validReferrerHost(host) { return typeof host === 'string' && (host === '' || hostPattern.test(host)); }

  function toHex(value) {
    return encodeURIComponent(value).replace(/%[a-f0-9]{2}|[^%]/gi, token =>
      token.length === 3 ? token.slice(1).toLowerCase() : token.charCodeAt(0).toString(16).padStart(2, '0'));
  }
  function fromHex(value) {
    if (!/^(?:[a-f0-9]{2})+$/i.test(value)) throw new Error('invalid_hex');
    return decodeURIComponent(value.replace(/../g, pair => '%' + pair));
  }
  function iso(value) {
    if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d{3})?Z$/.test(value)) throw new Error('invalid_time');
    const normalized = value.includes('.') ? value : value.replace('Z', '.000Z');
    const at = Date.parse(value);
    if (!Number.isFinite(at) || new Date(at).toISOString() !== normalized) throw new Error('invalid_time');
    return normalized;
  }
  function cleanSnapshot(value, reference) {
    if (!value || ![1, 2].includes(value.v) || !value.utm) throw new Error('invalid_snapshot');
    const at = iso(value.first_touch_at);
    const ref = typeof reference === 'number' ? reference : Date.parse(iso(reference));
    if (Date.parse(at) > ref + 300000 || ref - Date.parse(at) > maxAgeMs) throw new Error('snapshot_time_out_of_range');
    const utm = {};
    for (const k of parameters) {
      const text = value.utm[k];
      if (typeof text !== 'string' || text.length > 1024 || Array.from(text).some(char => char.charCodeAt(0) < 32 || char.charCodeAt(0) === 127)) throw new Error('invalid_utm');
      // Validate UTF-8 before creating tags; a lone surrogate must not change native submission.
      toHex(text);
      utm[k] = text;
    }
    const version = value.v === 2 || value.referrer_v === 2 ? 2 : 1;
    const cleaned = { v: version, first_touch_at: at, utm };
    if (version === 2) {
      const host = value.referrer_host;
      if (!validReferrerHost(host)) throw new Error('invalid_referrer_host');
      cleaned.referrer_host = host;
    }
    return cleaned;
  }
  function encode(snapshot, submittedAt, id) {
    if (!/^[a-f0-9]{32}$/.test(id)) throw new Error('invalid_id');
    iso(submittedAt);
    const s = cleanSnapshot(snapshot, submittedAt);
    if (s.first_touch_at > submittedAt) throw new Error('negative_elapsed');
    const values = [s.v, s.first_touch_at, submittedAt, ...parameters.map(k => s.utm[k])];
    if (s.v === 2) values.push(s.referrer_host);
    const hex = toHex(JSON.stringify(values));
    const count = Math.ceil(hex.length / chunkSize);
    if (count > maxChunks) throw new Error('payload_too_long');
    return Array.from({ length: count }, (_, i) => prefix + id + '_' + String(i + 1).padStart(2, '0') + '_' +
      String(count).padStart(2, '0') + '_' + hex.slice(i * chunkSize, (i + 1) * chunkSize));
  }
  function protocolTag(tag) { return typeof tag === 'string' && tagPattern.test(tag); }
  function decode(allTags, addedTags, reference) {
    if (!Array.isArray(allTags) || !Array.isArray(addedTags)) throw new Error('missing_tags');
    iso(reference);
    const ids = new Set(addedTags.map(tag => String(tag).match(tagPattern)).filter(Boolean).map(m => m[1].toLowerCase()));
    const groups = new Map();
    for (const raw of allTags) {
      const m = String(raw).match(tagPattern);
      if (!m || !ids.has(m[1].toLowerCase())) continue;
      const id = m[1].toLowerCase(); const index = Number(m[2]); const total = Number(m[3]);
      if (!groups.has(id)) groups.set(id, { total, parts: new Map(), tags: [], bad: false });
      const group = groups.get(id);
      if (total < 1 || total > maxChunks || total !== group.total || index < 1 || index > total ||
          m[4].length > chunkSize || m[4].length % 2 || (index < total && m[4].length !== chunkSize)) group.bad = true;
      const piece = m[4].toLowerCase();
      if (group.parts.has(index) && group.parts.get(index) !== piece) group.bad = true;
      group.parts.set(index, piece); group.tags.push(String(raw));
    }
    const packets = [];
    for (const [id, group] of groups) {
      if (group.bad || group.parts.size !== group.total) continue;
      try {
        const hex = Array.from({ length: group.total }, (_, i) => group.parts.get(i + 1)).join('');
        const p = JSON.parse(fromHex(hex));
        if (!Array.isArray(p) || !((p[0] === 1 && p.length === 8) || (p[0] === 2 && p.length === 9))) throw new Error('invalid_payload');
        const submittedAt = iso(p[2]);
        const ref = Date.parse(reference);
        if (Date.parse(submittedAt) > ref + 300000 || ref - Date.parse(submittedAt) > maxAgeMs) throw new Error('invalid_submission_time');
        const raw = { v: p[0], first_touch_at: p[1], utm: Object.fromEntries(parameters.map((k, i) => [k, p[i + 3]])) };
        if (p[0] === 2) raw.referrer_host = p[8];
        const snapshot = cleanSnapshot(raw, submittedAt);
        if (snapshot.first_touch_at > submittedAt) throw new Error('negative_elapsed');
        packets.push({ id, snapshot, submittedAt, tags: [...new Set(group.tags)] });
      } catch { /* Leave invalid/incomplete tags for inspection; never write partial data. */ }
    }
    return packets.sort((a, b) => a.submittedAt.localeCompare(b.submittedAt) || a.id.localeCompare(b.id));
  }
  return { prefix, maxAgeMs, parameters, fieldKeys, encode, decode, cleanSnapshot, protocolTag, validReferrerHost };
})();

/* Customer first-touch collection. Deployment and rollback are recorded alongside this release. */
(function () {
  'use strict';
  if (window.__vfUtmFlow || window.Shopify?.designMode) return;
  window.__vfUtmFlow = true;
  const storageKey = 'vf_first_touch_v1';
  const selector = 'form.qc-subscribe__form, form.qc-subscribe-sticky__form, form.email-signup__form';
  const formStates = new WeakMap();
  let snapshot = null;
  let privacyLoads = 0;

  function externalReferrerHost() {
    try {
      const url = new URL(document.referrer);
      if (!['http:', 'https:'].includes(url.protocol)) return '';
      const host = url.hostname.toLowerCase().replace(/\.$/, '');
      const own = new Set([location.hostname, 'vivifocal.com', 'www.vivifocal.com', 'ix1brv-ac.myshopify.com']);
      if (own.has(host) || host.endsWith('.vivifocal.com')) return '';
      // Only hostnames travel to customer fields; never paths, queries or credentials.
      return VFUTM.validReferrerHost(host) ? host : '';
    } catch (_) { return ''; }
  }

  function permitted() {
    try {
      const p = window.Shopify?.customerPrivacy;
      return p?.analyticsProcessingAllowed() === true && p?.marketingAllowed() === true;
    } catch (_) { return false; }
  }
  function nativeForm(form) {
    if (!form?.matches?.(selector) || form.method.toLowerCase() !== 'post') return false;
    const action = new URL(form.action, location.href);
    return action.origin === location.origin && /\/contact$/.test(action.pathname);
  }
  function tagInput(form) { return form.querySelector('input[name="contact[tags]"]'); }
  function baseTags(value) { return String(value).split(',').map(x => x.trim()).filter(x => x && !VFUTM.protocolTag(x)); }
  function stateFor(form) {
    if (!formStates.has(form)) {
      const input = tagInput(form);
      formStates.set(form, { input, base: input ? baseTags(input.value) : [], packet: null });
    }
    const state = formStates.get(form);
    const input = tagInput(form);
    if (input !== state.input) { state.input = input; state.base = input ? baseTags(input.value) : []; state.packet = null; }
    return state;
  }
  function restore(form) {
    if (!nativeForm(form)) return;
    const state = stateFor(form);
    if (state.input) state.input.value = state.base.join(',');
    state.packet = null;
  }
  function clear() {
    snapshot = null;
    try { localStorage.removeItem(storageKey); } catch (_) { /* blocked storage */ }
    document.querySelectorAll(selector).forEach(restore);
  }
  function observe() {
    if (!window.Shopify?.customerPrivacy) return;
    if (!permitted()) { clear(); return; }
    if (snapshot) return;
    const now = Date.now();
    try { snapshot = VFUTM.cleanSnapshot(JSON.parse(localStorage.getItem(storageKey)), now); } catch (_) { /* first permitted observation */ }
    if (!snapshot) {
      const query = new URLSearchParams(location.search);
      const utm = Object.fromEntries(VFUTM.parameters.map(k => [k, query.get(k) || '']));
      try { snapshot = VFUTM.cleanSnapshot({ v: 2, first_touch_at: new Date(now).toISOString(), utm, referrer_host: externalReferrerHost() }, now); }
      catch (_) { return; } // Invalid/oversize parameters fail closed; don't silently change attribution.
      // Keep the old storage envelope readable to already-open v1 pages during rollout.
      try { localStorage.setItem(storageKey, JSON.stringify({ ...snapshot, v: 1, referrer_v: 2 })); } catch (_) { /* this page only */ }
    }
  }
  function randomId() {
    const bytes = new Uint8Array(16);
    window.crypto.getRandomValues(bytes);
    return Array.from(bytes, b => b.toString(16).padStart(2, '0')).join('');
  }
  function prepare(form, fresh) {
    if (!nativeForm(form)) return;
    const state = stateFor(form);
    if (!state.input) return;
    if (!permitted()) { restore(form); return; }
    observe();
    if (!snapshot) { restore(form); return; }
    try {
      const now = Date.now();
      if (fresh || !state.packet || now - state.packet.at > 5000) {
        state.packet = { at: now, tags: VFUTM.encode(snapshot, new Date(now).toISOString(), randomId()) };
      }
      state.input.value = [...state.base, ...state.packet.tags].join(',');
    } catch (_) { restore(form); }
  }
  function formFrom(target) { return target?.closest?.(selector); }
  function preflight(event) {
    const form = formFrom(event.target);
    if (form) prepare(form, true);
  }
  // Prepare before Shopify's hCaptcha submit handler can serialize the form.
  document.addEventListener('focusin', preflight, true);
  document.addEventListener('change', preflight, true);
  document.addEventListener('input', preflight, true);
  document.addEventListener('pointerdown', event => {
    if (event.target.closest?.('button, input[type="submit"]')) preflight(event);
  }, true);
  document.addEventListener('click', event => {
    if (event.target.closest?.('button, input[type="submit"]')) preflight(event);
  }, true);
  document.addEventListener('keydown', event => { if (event.key === 'Enter') preflight(event); }, true);
  document.addEventListener('submit', event => {
    prepare(event.target, false);
    // No preventDefault, native .submit override, fetch, fbq, or customer mutation.
  }, true);
  document.addEventListener('formdata', event => {
    const form = event.target;
    if (!nativeForm(form)) return;
    prepare(form, false);
    const input = tagInput(form);
    if (input) event.formData.set('contact[tags]', input.value);
  });
  document.addEventListener('visitorConsentCollected', () => {
    if (!permitted()) clear();
    else observe();
  });
  document.addEventListener('shopify:section:load', observe);
  window.addEventListener('storage', event => {
    if (event.key === storageKey) { snapshot = null; document.querySelectorAll(selector).forEach(restore); observe(); }
  });
  window.addEventListener('pageshow', event => {
    if (event.persisted) document.querySelectorAll(selector).forEach(restore);
    observe();
  });
  function privacyReady() {
    if (window.Shopify?.customerPrivacy) { observe(); return; }
    if (window.Shopify?.loadFeatures) {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], error => { if (!error) observe(); });
    } else if (++privacyLoads <= 20) setTimeout(privacyReady, 250);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', privacyReady, { once: true });
  else privacyReady();
})();

})();

/* Product subscription navigation only. Customer first-touch collection remains separate. */
(function () {
  'use strict';
  const sourcePath = '/products/vivifocal-s1-eyewear';
  const targetPath = '/products/s1-adaptive-eyewear-2';
  if (location.pathname !== sourcePath || window.Shopify?.designMode || window.VFProductSubscribeUtm) return;

  const parameters = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  const storageKey = 'vf_product_subscribe_utm_v1';
  const maximumAge = 15 * 60 * 1000;
  const selector = 'form.qc-subscribe__form, form.qc-subscribe-sticky__form';
  const successPage = new URLSearchParams(location.search).get('customer_posted') === 'true';
  let resolvedTarget = null;

  function permission() {
    try {
      const privacy = window.Shopify?.customerPrivacy;
      if (typeof privacy?.analyticsProcessingAllowed !== 'function' || typeof privacy?.marketingAllowed !== 'function') return null;
      const analytics = privacy.analyticsProcessingAllowed();
      const marketing = privacy.marketingAllowed();
      if (typeof analytics !== 'boolean' || typeof marketing !== 'boolean') return null;
      return analytics && marketing;
    } catch (_) { return null; }
  }

  function removePending() {
    try { sessionStorage.removeItem(storageKey); } catch (_) { /* Native subscription still works. */ }
  }

  function cleanUtm(value) {
    if (!value || typeof value !== 'object') return null;
    const utm = {};
    for (const key of parameters) {
      const text = value[key];
      if (typeof text !== 'string' || text.length > 1024 || /[\u0000-\u001f\u007f]/.test(text)) return null;
      utm[key] = text;
    }
    return utm;
  }

  function currentUtm() {
    const query = new URLSearchParams(location.search);
    return cleanUtm(Object.fromEntries(parameters.map(key => [key, query.get(key) || ''])));
  }

  function validFormId(value) {
    return typeof value === 'string' && /^qc-subscribe-(?:sticky-)?[A-Za-z0-9_-]{1,180}$/.test(value);
  }

  function nativeForm(form) {
    try {
      if (!form?.matches?.(selector) || String(form.method).toLowerCase() !== 'post' || !validFormId(form.id)) return false;
      const action = new URL(form.action, location.href);
      return action.origin === location.origin && action.pathname === '/contact' && !action.username && !action.password;
    } catch (_) { return false; }
  }

  function savePending(form) {
    if (location.pathname !== sourcePath || successPage || !nativeForm(form)) return;
    const allowed = permission();
    if (allowed !== true) {
      removePending();
      return;
    }
    const utm = currentUtm();
    if (!utm) { removePending(); return; }
    try {
      // An empty current source replaces any previous pending source as one group.
      sessionStorage.setItem(storageKey, JSON.stringify({ v: 1, path: sourcePath, formId: form.id, submittedAt: Date.now(), utm }));
    } catch (_) { removePending(); }
  }

  function pendingUtm() {
    try {
      const value = JSON.parse(sessionStorage.getItem(storageKey));
      if (!value || value.v !== 1 || value.path !== sourcePath || !validFormId(value.formId) ||
          typeof value.submittedAt !== 'number' || !Number.isFinite(value.submittedAt)) return null;
      const elapsed = Date.now() - value.submittedAt;
      if (elapsed < 0 || elapsed > maximumAge) return null;
      if (location.hash && location.hash.slice(1) !== value.formId) return null;
      return cleanUtm(value.utm);
    } catch (_) { return null; }
  }

  function target(redirect) {
    let url;
    try {
      url = new URL(redirect, location.href);
      if (location.pathname !== sourcePath || url.origin !== location.origin || url.pathname !== targetPath || url.username || url.password) return redirect;
    } catch (_) { return redirect; }
    if (resolvedTarget !== null) return resolvedTarget;

    // Configured Website/ProductPage/Subscribe values never become a fallback source.
    for (const key of parameters) url.searchParams.delete(key);
    const current = currentUtm();
    let utm = current && parameters.some(key => current[key] !== '') ? current : null;
    if (successPage && permission() === true) utm = utm || pendingUtm();
    if (utm) for (const key of parameters) if (utm[key] !== '') url.searchParams.set(key, utm[key]);
    if (successPage) removePending();
    resolvedTarget = url.href;
    return resolvedTarget;
  }

  // Starting a normal product view invalidates another unfinished navigation.
  // Shopify's challenge page has a different path and never runs this helper.
  if (!successPage || permission() === false) removePending();
  document.addEventListener('submit', event => savePending(event.target), true);
  document.addEventListener('formdata', event => savePending(event.target), true);
  document.addEventListener('visitorConsentCollected', () => {
    if (permission() === false) {
      removePending();
      resolvedTarget = null;
    }
  });
  window.VFProductSubscribeUtm = { target };
})();
